import * as React from 'react';
import './index.scss';
import { Button, Modal, message, Popover, Input, Select, Spin } from 'antd';
import { DoubleRightOutlined, SmileOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import UserCard from '../userCard';
import dateFormat from 'dateformat';
import moment from 'moment';
import { checkToken, logout, isCasual, getMeetingOrderList, deleteMeetingOrder } from '../../model/api';
import Header from '../header';
import AddMeetingOrder from '../addMeetingOrder';
import { cloneDeep } from 'lodash';
import { timeMap, standardMap, locationMap } from '../addMeetingOrder/constants';

const { Option } = Select;
const { confirm } = Modal;

export default class Meeting extends React.Component {
  SHOW_DAYS = 7;
  _startDate = null;
  _dates = [];
  _weekday = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  _stateColors = ["lightgrey", "orange", "lime"];
  _selectText = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  _dinnerText = ['早餐', '午餐', '晚餐(仅限当天工作至20:30以后可预定)'];
  _locations = {
    '1': ["7层东侧茶水间", "8层西侧吧台", "9层东侧吧台", "10层西侧吧台", "11层东侧吧台", "东升大厦"],
    'keg': ["7层东侧茶水间", "FIT楼"],
  }
  _deadTime = [0, 9.5 * 60 * 60 * 1000, 17.5 * 60 * 60 * 1000];

  _timeLoop = null;

  timeNumberMap = {
    1: 9,
    2: 12,
    3: 19
  }

  constructor(props) {
    super(props);
    let now = new Date();
    this._startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    for (let i = 0; i < this.SHOW_DAYS; ++i) {
      this._dates.push(new Date(this._startDate.getTime() + i * 24 * 60 * 60 * 1000));
    }

    this.state = {
      currentDateIndex: 0,
      now: new Date(),
      showLogoutConfirm: false,
      user: null,
      loading: false,
      curList: [], // 当前选中日期的历史订餐数据集合
      total: 0, // 当前选中日期的历史订餐总数
      type: 'list', // 页面类型：add, edit, list
      selectedDate: null, //当前选中的日期
      editData: null,
    }
  }

  async componentDidMount() {
    await this.tokenAuth()
    // let parsed = parse(window.location.search);
    // let group = ""
    // if (parsed.group) {
    //   group = parsed.group;
    //   this.setState({ group: group });
    // }
    const data = JSON.parse(localStorage.getItem('user') || '{}')
    // if (data && data.name) {
    // let person = group_data.find(d => d.name == data.name);
    // if (person) {
    //   this.setState({
    //     testTip: tips[person.group].tip
    //   })
    // }
    // }
    this.setState({ user: data, selectedDate: dateFormat(this._startDate, 'yyyy-mm-dd') }, () => {
      this.getCurDateData();
    });
    this.SHOW_DAYS = 7;

    this._timeLoop = setInterval(() => this.setState({ now: new Date() }), 1000);
  }

  componentWillUnmount() {
    if (this._timeLoop) {
      clearInterval(this._timeLoop);
    }
  }

  tokenAuth = async () => {
    const isValid = await checkToken()
    // 如果未登录跳到登录
    if (!isValid) {
      this.props.history.push('/login')
    }
  }

  handleLogout = () => {
    logout();
    this.setState({ user: null, showLogoutConfirm: false });
    this.props.history.push('/login')
  }

  handleSelectDate = (date, index) => {
    this.setState({ currentDateIndex: index, selectedDate: dateFormat(date, 'yyyy-mm-dd') }, () => {
      this.getCurDateData()
    });
  }

  // 获取当前选择的日期的历史会议订餐数据
  getCurDateData = async () => {
    const { selectedDate, user } = this.state
    try {
      this.setState({ loading: true })
      const params = {
        userid: user?.id,
        date: selectedDate
      }
      const res = await getMeetingOrderList(params)
      if (res.code === 200 || res.code === 0) {
        const data = cloneDeep(res.data || [])
        data.forEach(item => {
          item.standard = item.expense
        })
        this.setState({ curList: data, total: data?.length || 0 })
      }
    } catch (err) {
      console.log("err=", err)
    } finally {
      this.setState({ loading: false })
    }
  }

  // 关闭新增页面，并刷新列表
  closeAdd = () => {
    this.setState({ type: 'list' })
    this.getCurDateData()
  }

  deleteOrder = async (id) => {
    try {
      const res = await deleteMeetingOrder({ id })
      if (res.code === 200 || res.code === 0) {
        message.success('会议订餐取消成功')
        this.getCurDateData()
      }
    } catch (err) {
      console.log("err=", err)
    }
  }

  deleteConfirm = (id) => {
    confirm({
      title: '请确认是否要取消该会议订餐',
      icon: <ExclamationCircleOutlined />,
      centered: true,
      className: 'order-delete-modal',
      width: 320,
      content: '',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        this.deleteOrder(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  // 禁用时间
  disabledTime = (inputHour) => {
    if (!inputHour) return true
    const nowDate = dateFormat(new Date(), 'yyyy-mm-dd')

    if (nowDate === this.state.selectedDate) {// 选择的是今天
      const now = moment();
      const inputTime = moment().hour(inputHour).minute(0).second(0);

      // 当前时间小于传入时间
      if (now.isBefore(inputTime)) {
        const diffInMinutes = inputTime.diff(now, 'minutes');
        if (diffInMinutes < 60) {
          return true;
        } else {
          return false;
        }
      }
      // 当前时间大于或等于传入时间
      return true;
    }
    return false
  };

  render() {
    const { user, currentDateIndex, loading, curList, total, type, selectedDate, editData } = this.state;
    return (
      <div className='meeting-order'>
        {
          !!user && (
            <div className='order-inner'>
              <Header {...this.props} type="meeting" />
              <div className='order-user'>
                <UserCard data={user} isCasual={isCasual()} isMeeting={true} />
              </div>
              <Spin spinning={loading} indicator={<></>} tip="正在加载历史会议订餐...">
                <div className='order-dates'>
                  {this._dates.map((date, i) => {
                    if (i >= this.SHOW_DAYS) return null;
                    return (
                      <div className='order-date' key={i} style={{ color: i == currentDateIndex ? "#0095ff" : "dimgrey", fontWeight: i == currentDateIndex ? "bold" : "normal" }} onClick={() => this.handleSelectDate(date, i)}>
                        <div className='order-date-date'>{dateFormat(date, 'yy/mm/dd')}</div>
                        <div className='order-date-week'>{this._weekday[date.getDay()]}</div>
                      </div>
                    )
                  })}
                </div>
                {type === 'list' && <div className='order-content'>
                  <div className='order-header'>
                    <div className='order-total'>今日会议订餐：<span>{total}</span></div>
                    {(!this.disabledTime(9) || !this.disabledTime(12) || !this.disabledTime(19)) &&
                      <div className='order-jump' onClick={() => this.setState({ type: 'add' })}>
                        去会议订餐 <DoubleRightOutlined style={{ fontSize: 12 }} />
                      </div>}
                  </div>
                  <div className='order-list'>
                    {curList.map((item, index) => {
                      return <div className='order-list-item' key={item.id}>
                        <div className='order-item-row'><span className='col-label'>送餐时间:</span>{timeMap[item.time]}</div>
                        <div className='order-item-row'><span className='col-label'>订餐事由:</span>{item.reason}</div>
                        <div className='order-item-row'><span className='col-label'>餐标:</span>{standardMap[item.standard]}</div>
                        <div className='order-item-row'><span className='col-label'>配送区域:</span>{locationMap[item.location]}</div>
                        <div className='order-item-row'><span className='col-label'>数量:</span>{item.number}</div>
                        {!this.disabledTime(this.timeNumberMap[item.time]) && <>
                          <div className='order-item-row-edit' onClick={() => this.setState({ type: 'edit', editData: item })}>去修改 <DoubleRightOutlined style={{ fontSize: 12 }} /></div>
                          <div className='order-item-row-delete' onClick={() => this.deleteConfirm(item.id)}>取消订餐</div>
                        </>}
                      </div>
                    })}
                    {!curList?.length && <div className='order-empty'>
                      <SmileOutlined style={{ fontSize: 20 }} />
                      <div className='order-empty-desc'>今天还没有点餐哦</div>
                    </div>}
                  </div>
                </div>}
                {(type === 'add' || type === 'edit') && <AddMeetingOrder type={type} onClose={this.closeAdd} selectedDate={selectedDate} editData={editData} />}
              </Spin>
              <Modal
                title="退出确认"
                open={this.state.showLogoutConfirm}
                onOk={this.handleLogout}
                onCancel={() => this.setState({ showLogoutConfirm: false })}
                okText="退出">
                <div>确认退出登录么？</div>
              </Modal>
            </div>
          )
        }
      </div>
    )
  }
}